




















import VueQrcode from "@chenfengyuan/vue-qrcode";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MemberEventNumberQrCodeComponent",
  components: {
    VueQrcode,
  },
})
export default class MemberEventNumberQrCodeComponent extends Vue {
  public isShow = false;
  public url = null;

  public show(url: any = "") {
    this.initComponent();

    this.url = url;
    this.isShow = true;
  }

  public initComponent() {
    this.url = null;
  }

  public cancel() {
    this.close();
  }

  public close() {
    this.isShow = false;
    this.$emit("close");
  }
}
